import { render } from "./Widget12.vue?vue&type=template&id=c3d4b164"
import script from "./Widget12.vue?vue&type=script&lang=js"
export * from "./Widget12.vue?vue&type=script&lang=js"
script.render = render

export default script